// Model.js
// -----------------------
// @module Case
define("Mailchimp.SS2Model", ["Backbone", "Utils"], function (
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/MailchimpTracker/SuiteScript2/Mailchimp.Service.ss"
            ),
            true
        )
    });
});

